export const xsightBuildInfo = {
  buildNumber: '11824',
  buildName: 'release/25.1.0',
  branch: 'release/25.1.0',
};

// dont run if angularjs not present
if (!!window.angular) {
  (function (module) {
    'use strict';

    module.value('buildInfo', xsightBuildInfo);
  })(angular.module('about'));
}
